import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ElementLoaderComponent } from '../loader/element-loader.component';

@Component({
  selector: 'app-loading',
  imports: [ElementLoaderComponent],
  template: `
    <div class="loading-container">
      <app-element-loader></app-element-loader>
    </div>
  `,
  styles: [`
    .loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100vw;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent { }
